import { FC } from 'react';
import { Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationAttendee } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReportAttendeeForm = {
	lists: OfficeObservationAttendee<'payload'>[];
};

const FBDHSiteVisitReportAttendee: FC = () => {
	const { siteReport } = useFBDHVisitReportApprovalPage();

	const { form, fieldName } = useForm<VisitReportAttendeeForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>Pihak Yang Hadir</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists: siteReport?.attendees ?? [],
					} as VisitReportAttendeeForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReportAttendeeForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Nama',
										render: (_, record) => record.name ?? '-',
									},
									{
										title: 'Jabatan',
										render: (_, record) => record.position ?? '-',
									},
									{
										title: 'Nama Perusahaan',
										render: (_, record) => record.companyName ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
		</Form.Provider>
	);
};

export default FBDHSiteVisitReportAttendee;
